import { IconBriefcase } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { SubcontractorSelectCaptureBlock as RenderSubcontractorSelectCaptureBlock } from '../../templateRenderer/CaptureBlocks/SubcontractorSelectCaptureBlock'
import { SubcontractorSelectDisplayBlock as RenderSubcontractorSelectDisplayBlock } from '../../templateRenderer/DisplayBlocks/SubcontractorSelectDisplayBlock'
import { GenericResource } from '../../templateRenderer/GenericResourceSelector'
import {
  SubcontractorSelectCaptureBlock,
  SubcontractorSelectDisplayBlock,
} from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  SwitchField,
  TypeOption,
} from './_BaseBlockConfig'

import { createCommaSeparatedString } from '@/utils/createCommaSeparated'

class Config extends BaseBlockConfig<SubcontractorSelectCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'subcontractorSelect' as const

  public override enableBlockToCsvColumn = true
  public override enableBlockToColumnDisplay = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Company Select',
    icon: IconBriefcase,
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
    helpText: 'Search for and select companies from your directory',
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'multiSelect',
      label: 'Multiple',
      helpText: 'Whether to allow selecting multiple subcontractors',
      field: SwitchField,
      default: false,
    },
  ]

  public override mapFormValueToBlock(
    block: SubcontractorSelectCaptureBlock,
    value: GenericResource[]
  ): SubcontractorSelectCaptureBlock {
    return { ...block, value: value?.map((v) => ({ id: v.id, name: v.label })) }
  }

  public override renderBlock(
    block: SubcontractorSelectCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderSubcontractorSelectCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: SubcontractorSelectDisplayBlock
  ): React.ReactNode {
    return <RenderSubcontractorSelectDisplayBlock block={block} />
  }

  public override mapBlockToColumnDisplay(
    block: SubcontractorSelectCaptureBlock
  ): React.ReactNode {
    return (
      <RenderSubcontractorSelectDisplayBlock
        maxWidth={300}
        block={{
          type: 'subcontractorSelect',
          kind: 'display',
          value: block.value,
        }}
      />
    )
  }

  public override mapBlockToCsvValue(
    block: SubcontractorSelectCaptureBlock
  ): string | null {
    if (!block?.value?.length) return null

    return createCommaSeparatedString(
      block.value.map((v) => v.name),
      true
    )
  }
}

export const SubcontractorSelectCaptureBlockConfig = new Config()
